export const SET_IMPORT_ITEMS = 'SET_IMPORT_ITEMS';
export const SET_IMPORT_ITEMS_LOADING = 'SET_IMPORT_ITEMS_LOADING';
export const SET_IMPORT_ITEMS_LOADING_ERROR = 'SET_IMPORT_ITEMS_LOADING_ERROR';
export const CLEAR_IMPORT_ITEMS_DATA = 'CLEAR_IMPORT_ITEMS_DATA';
export const ADD_ITEM_COLUMN_MAPPING = 'ADD_ITEM_COLUMN_MAPPING';
export const FETCH_COLUMNS_LOADING = 'FETCH_COLUMNS_LOADING';
export const SET_COLUMNS = 'SET_COLUMNS';
export const FETCH_COLUMNS_LOADING_ERROR = 'FETCH_COLUMNS_LOADING_ERROR';
export const FETCH_EXISTING_EXPORT_CONFIG_LOADING =
  'FETCH_EXISTING_EXPORT_CONFIG_LOADING';
export const FETCH_EXISTING_EXPORT_CONFIG_LOADING_ERROR =
  'FETCH_EXISTING_EXPORT_CONFIG_LOADING_ERROR';
export const SET_EXISTING_EXPORT_CONFIG = 'SET_EXISTING_EXPORT_CONFIG';
export const SAVE_LOADING = 'SAVE_LOADING';
export const SAVE_SUCCESS = 'SAVE_SUCCESS';
export const SAVE_LOADING_ERROR = 'SAVE_LOADING_ERROR';
export const CLEAR_ERROR_SUCCESS = 'CLEAR_ERROR_SUCCESS';

export const SET_IMPORT_ITEMS_DATA_LOADING = 'SET_IMPORT_ITEMS_DATA_LOADING';
export const SET_IMPORT_ITEMS_DATA = 'SET_IMPORT_ITEMS_DATA';
export const SET_IMPORT_ITEMS_DATA_LOADING_ERROR =
  'SET_IMPORT_ITEMS_DATA_LOADING_ERROR';
export const DELETE_IMPORT_EXPORT_CONFIG_LOADING =
  'DELETE_IMPORT_EXPORT_CONFIG_LOADING';
export const DELETE_IMPORT_EXPORT_CONFIG = 'DELETE_IMPORT_EXPORT_CONFIG';
export const DELETE_IMPORT_EXPORT_CONFIG_LOADING_ERROR =
  'DELETE_IMPORT_EXPORT_CONFIG_LOADING_ERROR';
export const FETCH_EXISTING_IMPORT_CONFIG_LOADING =
  'FETCH_EXISTING_IMPORT_CONFIG_LOADING';
export const SET_EXISTING_IMPORT_CONFIG = 'SET_EXISTING_IMPORT_CONFIG';
export const FETCH_EXISTING_IMPORT_CONFIG_LOADING_ERROR =
  'FETCH_EXISTING_IMPORT_CONFIG_LOADING_ERROR';



// WEBPACK FOOTER //
// ./src/pages/utilities/state/importExport/types.js